<template>
  <div class="card my-3 px-3 py-3">
    <h5 style="color: #000">{{ title }}</h5>
    <apexchart type="bar" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  props: ['title', 'values', 'categories'],
  data: function() {
    return {
      chartOptions: {
        chart: {
          id: "barchart"
        },
        theme: {
          palette: "palette6"
        },
        xaxis: {
          categories: this.categories
        },
      },
      series: this.values
    };
  }
};
</script>